export default {
  appId: '6638ce4cf0e07abbe513a25f',
  apiUrl: 'https://api.bricodes.com',
  storageUrl: 'https://storage.bricodes.com',
  sentryDsn: 'https://ef8a0eaf088f44d1b86bda92dd989f73@sentry.io/1503419',
  languageCode: 'pl',
};
